import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import DashboardNavBar from './DashboardNavBar';
import PurchasedVideos from './PurchasedVideos';
import DashboardFeedback from './DashboardFeedback';
import Recordings from './Recordings';
import SubscriptionManagement from '../subscription/SubscriptionManagement';
import AdminSubscriptionManagement from '../subscription/AdminSubscriptionManagement';
import { media } from '../../utils/media';

const Dashboard = () => {
  const user = useSelector((state) => state.auth.user);
  
  // Check if user has access to recordings (site owners and admins only)
  const hasRecordingsAccess = user && user.roles && (
    user.roles.includes('ADMIN') || user.roles.includes('SITE_OWNER')
  );

  // Check if user has access to admin subscription management (admins only)
  const hasAdminSubscriptionAccess = user && user.roles && user.roles.includes('ADMIN');
  
  // All authenticated users should have access to their own subscription management
  // Check if user exists (any authenticated user can access their subscription)
  const hasUserSubscriptionAccess = !!user;

  return (
    <DashboardContainer>
      <DashboardNavBar 
        hasRecordingsAccess={hasRecordingsAccess} 
        hasSubscriptionAccess={hasUserSubscriptionAccess}
        hasAdminSubscriptionAccess={hasAdminSubscriptionAccess}
      />
      <ContentWrapper>
        <Routes>
          <Route index element={<Navigate to="purchased-videos" replace />} />
          <Route path="purchased-videos" element={<PurchasedVideos />} />
          <Route path="feedback" element={<DashboardFeedback />} />
          {hasUserSubscriptionAccess && (
            <Route path="subscription" element={<SubscriptionManagement />} />
          )}
          {hasAdminSubscriptionAccess && (
            <Route path="admin-subscription" element={<AdminSubscriptionManagement />} />
          )}
          {hasRecordingsAccess && (
            <Route path="recordings" element={<Recordings />} />
          )}
        </Routes>
      </ContentWrapper>
    </DashboardContainer>
  );
};

export default Dashboard;

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.appBackground};
  position: relative;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  flex: 1;
  padding: 40px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  transition: all 0.3s ease;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: ${({ theme }) => theme.colors.primaryBackground};
    border-radius: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    z-index: -1;
  }

  ${media.tablet`
    padding: 30px 20px;
    margin: 20px;
    max-width: calc(100% - 40px);
  `}

  ${media.mobile`
    padding: 20px 15px;
    margin: 15px;
    max-width: calc(100% - 30px);
  `}
`;
